(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MusicalArrangementIbqDeleteController',MusicalArrangementIbqDeleteController);

    MusicalArrangementIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'MusicalArrangement'];

    function MusicalArrangementIbqDeleteController($uibModalInstance, entity, MusicalArrangement) {
        var vm = this;

        vm.musicalArrangement = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MusicalArrangement.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
